import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Button, Grid, SectionTitle, Typography, Text } from '@blueprint/ui';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { axiosInstance } from '../../functions/axios';
import SingleSelectionAck from './SingleSelectionAck';
import MultipleSelectionAck from './MultipleSelectionAck';
import multiplePaymentsColumns from '../PaymentBankDetails/multiplePaymentsColumns';
import CustomerLogo from '../CustomerLogo/CustomerLogo';
import { useReactToPrint } from 'react-to-print';
import './ack.css';
import hsbcLogo from '../../media/hsbcLogo.png';
import Pdf from 'react-to-pdf';
import { downloadFile } from '../../functions/downloadFile';

const AcknowledgementPlaceholder = styled.div`
    // padding-top: 10px;
    padding-right: 5vw;
    padding-left: 5vw;
    //padding-bottom: 5em;
`;

const StyledLink = styled(Link)`
    color: black;
    text-decoration: underline;

    &:hover {
        color: black;
        cursor: pointer;
    }
`;

const Acknowledgement = ({ location }) => {
    const FETCH_ENRICHEMENT_DETAILS_URL = process.env.REACT_APP_FETCH_ENRICHEMENT_DETAILS_URL;
    const PAYMENT_LIST = process.env.REACT_APP_PAYMENT_LIST;
    const history = useHistory();
    const { t } = useTranslation();
    const globalState = useSelector((state) => state);
    const footerHeight = globalState.beneDetails.footerHeight;
    const componentRef = useRef();
    const ref = React.createRef();

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/');
        }
    }, [globalState, history]);
    const isRegisteredUser = useSelector((state) => state.beneDetails.registeredUser);

    const [enrichmentDetails, setEnrichmentDetails] = useState(null);
    const [showFxRate, setShowFxRate] = useState(false);
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [showPaypalEmail, setShowPaypalEmail] = useState(false);
    const [singleSelection, setSingleSelection] = useState(true);
    const [transactions, setTransactions] = useState([]);

    const [paymentMethod, setPaymentMethod] = useState(false);

    useEffect(() => {
        const getEnrichmentDetails = async () => {
            const response = await axiosInstance.post(
                FETCH_ENRICHEMENT_DETAILS_URL,
                JSON.stringify({
                    stagePaymentId: location.state.stagePaymentId,
                })
            );
            if (response) {
                if (response.status === 200) {
                    const responseJson = response.data;
                    setEnrichmentDetails(responseJson);
                    setTransactions(responseJson.transactions);

                    if (responseJson.bankDisplayValue === null) {
                        setPaymentMethod('paypal');
                    } else {
                        setPaymentMethod('bank');
                    }

                    if (responseJson.fxRate !== null && responseJson.transactionType === 'FIXED_DEBIT') {
                        setShowFxRate(true);
                    }

                    if (responseJson.bankDisplayValue != null) {
                        setShowBankDetails(true);
                    }
                    if (responseJson.wallet !== null) {
                        setShowPaypalEmail(true);
                    }

                    if (responseJson.transactions.length === 1) {
                        setSingleSelection(true);
                    } else {
                        setSingleSelection(false);
                    }
                } else {
                    console.log('Handle Error');
                }
            }
        };
        getEnrichmentDetails();
    }, [FETCH_ENRICHEMENT_DETAILS_URL, globalState.beneDetails.details.emailId, location?.state?.stagePaymentId]);

    if (enrichmentDetails !== null) {
        var payerReference = enrichmentDetails.transactions[0].custBeneInfo;
        var payerCurrency = enrichmentDetails.instructedCurrency;
        var payoutCurrency = enrichmentDetails.accountCurrencycode;
        var payoutAmount = enrichmentDetails.totalAmount;
        var fxRate = enrichmentDetails.fxRate;
        if (enrichmentDetails.wallet != null) {
            var paypalEmail = enrichmentDetails.wallet.walletAccountValue;
        }

        var coolingOffPeriod = enrichmentDetails.coolingOffPeriod;
        var bankDisplayValue = enrichmentDetails.bankDisplayValue;
        var addressDisplayValue = enrichmentDetails.addressDisplayValue;

        var showTotalPayerAmount = false;
        var totalPayerAmount = 0;
        if (enrichmentDetails.transactions.length > 1 && enrichmentDetails.transactionType === 'FIXED_DEBIT') {
            let total = 0;
            showTotalPayerAmount = true;
            for (let i = 0; i < transactions.length; i++) {
                total += transactions[i].instructedAmount;
            }
            totalPayerAmount = total;
            console.log('Calculated payerAmount is ', totalPayerAmount);
        }
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const generatePaymentAckPdf = () => {
        const generatePaymentAckPdfCall = async () => {
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: '/generatePaymentAckPdf',
                    responseType: 'arraybuffer',
                    params: {
                        stagePaymentId: location.state.stagePaymentId,
                    },
                });
                if (response.status === 200) {
                    console.log(`Logging pdf response`, response.data);
                    var fileData = [response.data];
                    // Make blob of the JSON data
                    var blob = new Blob(fileData, { type: 'application/pdf' });
                    downloadFile(blob, 'Acknowledgement', 'pdf');
                }
            } catch (error) {
                console.error(`Logging /generatePaymentAckPdf error`, error);
            }
        };
        generatePaymentAckPdfCall();
    };

    return (
        <>
            <div ref={componentRef}>
                <div style={{ paddingLeft: '5vw', paddingRight: '5vw', paddingTop: '30px' }}>
                    <img className='navbar-brand' src={hsbcLogo} alt='Logo' style={{ height: '38px', width: 'auto', marginBottom: '2vw' }} />
                </div>

                <AcknowledgementPlaceholder>
                    <Grid container style={{ paddingTop: '8px' }}>
                        <CustomerLogo />
                        <Grid container>
                            <Box marginBottom={['5px', '5px', '5px', '24px']}>
                                <Box borderLeft='3px solid red' paddingLeft='10px'>
                                    <Typography variant='h1' id='ack-sectionTitle' className='page-title' tabIndex='-1'>
                                        {t('acknowledgementPage.section_title')}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid container xs={12}>
                            <Grid item>
                                <Box marginBottom={['10px', '10px', '10px', '24px']} maxWidth='600px'>
                                    <Typography variant='body1'>{t('acknowledgementPage.cnf_label')}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        {singleSelection ? (
                            <SingleSelectionAck
                                payerReference={payerReference}
                                payoutCurrency={payoutCurrency}
                                payoutAmount={payoutAmount}
                                showFxRate={showFxRate}
                                showPaypalEmail={showPaypalEmail}
                                paypalEmail={paypalEmail}
                                showBankDetails={showBankDetails}
                                bankDisplayValue={bankDisplayValue}
                                addressDisplayValue={addressDisplayValue}
                                fxRate={fxRate}
                                coolingOffPeriod={coolingOffPeriod}
                            />
                        ) : (
                            <MultipleSelectionAck
                                tableData={transactions}
                                columns={multiplePaymentsColumns}
                                payoutAmount={payoutAmount}
                                payoutCurrency={payoutCurrency}
                                showFxRate={showFxRate}
                                fxRate={fxRate}
                                showPaypalEmail={showPaypalEmail}
                                paypalEmail={paypalEmail}
                                showBankDetails={showBankDetails}
                                bankDisplayValue={bankDisplayValue}
                                addressDisplayValue={addressDisplayValue}
                                showTotalPayerAmount={showTotalPayerAmount}
                                payerCurrency={payerCurrency}
                                totalPayerAmount={totalPayerAmount}
                                coolingOffPeriod={coolingOffPeriod}
                            />
                        )}
                        <Grid container>
                            <Box marginBottom={2} maxWidth='600px'>
                                <Typography variant='body1'>
                                    {t('acknowledgementPage.note_label', {
                                        coolingOffPeriod,
                                    })}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </AcknowledgementPlaceholder>
            </div>
            <AcknowledgementPlaceholder role='main' style={{ paddingBottom: `${footerHeight + 20}px` }}>
                <Grid container>
                    {!isRegisteredUser ? (
                        <Grid container>
                            <Box maxWidth='600px' paddingBottom='1em' marginTop={['24px', '24px', '24px', '24px']}>
                                <Typography variant='body1'>
                                    {t('acknowledgementPage.registration_label')}
                                    &nbsp;
                                    <StyledLink to='/registration1' aria-label='Click here to register'>
                                        {t('acknowledgementPage.register_link')}
                                    </StyledLink>
                                </Typography>
                            </Box>
                        </Grid>
                    ) : null}
                    <Grid container>
                        <Box marginBottom={2} maxWidth='600px'>
                            <Typography variant='body1'>{t('acknowledgementPage.contact_label')}</Typography>
                        </Box>
                    </Grid>
                    <Box
                        display='flex'
                        flexDirection='row'
                        justifyContent='flex-end'
                        width='100%'
                        maxWidth='600px'
                        borderTop='1px solid #333'
                        paddingTop='1em'
                    >
                        {/* <Box paddingLeft='1em' className='no-printme'>
                            <Pdf targetRef={componentRef} filename='Acknowledgement.pdf'>
                                {({ toPdf }) => (
                                    <Button variant='light.tertiary' onClick={toPdf}>
                                        {t('acknowledgementPage.save_button')}
                                    </Button>
                                )}
                            </Pdf>
                        </Box> */}
                        <Box paddingLeft='1em' className='no-printme'>
                            <Button variant='light.tertiary' onClick={generatePaymentAckPdf}>
                                {t('acknowledgementPage.save_button')}
                            </Button>
                        </Box>
                        <Box paddingLeft='1em' className='no-printme'>
                            <Button variant='light.tertiary' onClick={handlePrint}>
                                {t('acknowledgementPage.print_button')}
                            </Button>
                        </Box>

                        <Box paddingLeft='1em' className='no-printme'>
                            <Button
                                id='ack-button-okay'
                                variant='light.primary'
                                onClick={() => {
                                    history.push(PAYMENT_LIST);
                                }}
                            >
                                {t('acknowledgementPage.ok_button')}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </AcknowledgementPlaceholder>
        </>
    );
};

export default Acknowledgement;
